import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getIcon } from '@cwos/ui-shared';
import styles from './Icon.module.css';
export function Icon({ name, size = 16, className, title, strokeWidth = 2 }) {
    const def = getIcon(name);
    if (!def)
        return null;
    const cls = className ? `${styles.icon} ${className}` : styles.icon;
    return (_jsxs("svg", { className: cls, width: size, height: size, viewBox: "0 0 24 24", fill: def.filled ? 'currentColor' : 'none', stroke: def.filled ? 'none' : 'currentColor', strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", role: title ? 'img' : undefined, "aria-hidden": title ? undefined : true, "aria-label": title, children: [title ? _jsx("title", { children: title }) : null, def.paths.map((d, i) => (_jsx("path", { d: d }, i)))] }));
}
//# sourceMappingURL=Icon.js.map